export default {
    handle(bloodDonorModel) {
        if (!bloodDonorModel.plasmaBloodDonorStatus) {
            return true;
        }

        if (bloodDonorModel.plasmaBloodDonorStatus !== 'other') {
            return true;
        }

        if (!bloodDonorModel.plasmaBloodDonorStatusOther) {
            bloodDonorModel.plasmaBloodDonorStatus = null;

            return true;
        }

        bloodDonorModel.plasmaBloodDonorStatus = !!bloodDonorModel.plasmaBloodDonorStatusOther
            ? bloodDonorModel.plasmaBloodDonorStatusOther
            : bloodDonorModel.plasmaBloodDonorStatus;

        return true;
    }
}